import dayjs from 'dayjs';

/**
 * A patient's age in whole years, from a date of birth that carries no zone.
 *
 * The server sends `DOB` as a calendar date ("1958-03-15T00:00:00", Kind Unspecified). Reading it
 * through a time zone can move it a day — and a birthday across the line changes the age — so only
 * the date part is read. Null when it cannot be read, or when the result is outside 0–129 (a
 * placeholder year, not a person).
 *
 * Promoted from Merchant.Web `heart/member/cardiac-cells.tsx` on 2026-10-19 so the shared patient
 * picker could use it; that file re-exports it and `cardiac-dates.test.ts` still pins it.
 */
export const ageFromDob = (dob: string | dayjs.Dayjs | null | undefined): number | null => {
  if (!dob) return null;
  const d = dayjs.isDayjs(dob) ? dob : dayjs(String(dob).substring(0, 10), 'YYYY-MM-DD');
  if (!d.isValid()) return null;
  const years = dayjs().diff(d, 'year');
  return years >= 0 && years < 130 ? years : null;
};
